import PropTypes from 'prop-types'
import React from 'react'

const BuyButton = ({ label, disabled, update, classes, isBlock, dataCy }) => (
  <a
    className={disabled ? `${classes} disabled` : classes}
    data-cy={dataCy}
    onClick={e => !disabled && update(e)}
    style={{ width: isBlock ? '100%' : null }}
  >
    <span>{label}</span>
  </a>
)

BuyButton.defaultProps = {
  disabled: false,
  isBlock: false,
  dataCy: '',
}

BuyButton.propTypes = {
  update: PropTypes.func.isRequired,
  dataCy: PropTypes.string,
  label: PropTypes.string.isRequired,
  classes: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isBlock: PropTypes.bool,
}

export default BuyButton
